/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Pattern1 from 'Admin/assets/img/Pattern1.jpg';
import Pattern2 from 'Admin/assets/img/Pattern2.jpg';
import Pattern3 from 'Admin/assets/img/Pattern3.jpg';
import Pattern4 from 'Admin/assets/img/Pattern4.jpg';
import Pattern5 from 'Admin/assets/img/Pattern5.jpg';
import Pattern6 from 'Admin/assets/img/Pattern6.jpg';
import Pattern7 from 'Admin/assets/img/Pattern7.jpg';
import Pattern8 from 'Admin/assets/img/Pattern8.jpg';
import Pattern9 from 'Admin/assets/img/Pattern9.png';
import Pattern10 from 'Admin/assets/img/Pattern10.png';
import Pattern11 from 'Admin/assets/img/Pattern11.png';
import Pattern12 from 'Admin/assets/img/Pattern12.png';
import Pattern13 from 'Admin/assets/img/Pattern13.png';
import Pattern14 from 'Admin/assets/img/Pattern14.png';
import Pattern15 from 'Admin/assets/img/Pattern15.png';

class PatternPreview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      patternName: this.props.pattern ? Number(this.props.pattern) : '',
    };


  }

  componentDidMount() {
    let patternName = this.state.patternName;

    if (patternName === 1) {
      this.setState({ previewImage: Pattern1 });

    } else if (patternName === 2) {
      this.setState({ previewImage: Pattern2 });

    } else if (patternName === 3) {
      this.setState({ previewImage: Pattern3 });

    } else if (patternName === 4) {
      this.setState({ previewImage: Pattern4 });

    } else if (patternName === 5) {
      this.setState({ previewImage: Pattern5 });

    } else if (patternName === 6) {
      this.setState({ previewImage: Pattern6 });

    } else if (patternName === 7) {
      this.setState({ previewImage: Pattern7 });

    } else if (patternName === 8) {
      this.setState({ previewImage: Pattern8 });

    } else if (patternName === 9) {
      this.setState({ previewImage: Pattern9 });

    } else if (patternName === 10) {
      this.setState({ previewImage: Pattern10 });

    } else if (patternName === 11) {
      this.setState({ previewImage: Pattern11 });

    } else if (patternName === 12) {
      this.setState({ previewImage: Pattern12 });

    } else if (patternName === 13) {
      this.setState({ previewImage: Pattern13 });

    } else if (patternName === 14) {
      this.setState({ previewImage: Pattern14 });

    } else if (patternName === 15) {
      this.setState({ previewImage: Pattern15 });

    }

  }

  render() {

    return (
      <Row>
        <Col sm={12} className="patienSearchBox">
          <FormGroup>
            <Col sm={12}>
              <div className="patternBox">
                <img className="patternImage" src={this.state.previewImage} alt="img" />
              </div>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {}
}

export default PatternPreview;
